import React, { memo } from 'react';
import classNames from 'classnames';

import FormGroup from '../../../helpers/FormGroup';
import Textarea from '../../../helpers/Textarea';
import Select from '../../../helpers/Select';
import Input from '../../../helpers/Input';
import { FundCompanies } from './FundCompanies';
import { Card } from '../../../helpers/Card';

import style from './style.module.css';

const FundComponent = ({
  canEditData,
  fund: root,
  isResearcherUser,
  onChange,
  onGetNext,
  onRowDoubleClick,
  onSort,
  onCellClick,
  onCellValueChange,
  onRef,
}) => (
  <div className={classNames(style.host, 'tab-pane active tab-target')} id="buy-slide-6">
    <Card as="form" className={style.form} onChange={onChange}>
      <FormGroup>
        <Input
          className="input-sm"
          disabled={!canEditData || isResearcherUser}
          label="Current Fund"
          name="currentFund"
          placeholder="Current Fund"
          root={root}
          deep
          showLabel
        />
      </FormGroup>
      <FormGroup>
        <Input
          className="input-sm"
          disabled={!canEditData || isResearcherUser}
          label="Size"
          name="fundSize"
          placeholder="Size"
          root={root}
          deep
          showLabel
        />
      </FormGroup>
      <FormGroup>
        <Select
          disabled={!canEditData || isResearcherUser}
          label="Year Raised"
          name="fundYearRaised"
          onChange={onChange}
          options={root.get('years')}
          root={root}
          deep
          showLabel
        />
      </FormGroup>
      <FormGroup>
        <Textarea
          disabled={!canEditData || isResearcherUser}
          label="Notes"
          name="fundNotes"
          placeholder="Notes"
          root={root}
          deep
          showLabel
        />
      </FormGroup>
    </Card>
    <FundCompanies
      funds={root.get('funds')}
      loading={root.get('loading')}
      onCellClick={onCellClick}
      onCellValueChange={onCellValueChange}
      onGetNext={onGetNext}
      onRef={onRef}
      onRowDoubleClick={onRowDoubleClick}
      onSort={onSort}
      page={root.get('page')}
      totalPages={root.get('totalPages')}
    />
  </div>
);

export const Fund = memo(FundComponent);
